export default __webpack_public_path__ + "static/media/kittles-outdoor-sport.798cb658.jpg";